export function countdown() {
    const countdowns = document.querySelectorAll('[data-countdown]');

    function renderCountdown(countdown) {
        return countdown.insertAdjacentHTML('afterbegin',
            `<div class="item days"><strong></strong><span>days</span></div>
             <div class="item hours"><strong></strong><span>hours</span></div>
             <div class="item minutes"><strong></strong><span>minutes</span></div>`
        )
    }

    function getTimeRemaining(endTime) {
        const now = new Date().getTime();
        const countDownDate = new Date(endTime).getTime();
        const time = countDownDate - now;
        // const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        const days = Math.floor(time / (1000 * 60 * 60 * 24));

        return {
            'total': time,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            // 'seconds': seconds
        };
    }

    function initializeCountdown(countdown, endTime) {
        renderCountdown(countdown);

        const days = countdown.querySelector('.days strong');
        const hours = countdown.querySelector('.hours strong');
        const minutes = countdown.querySelector('.minutes strong');
        // const seconds = countdown.querySelector('.seconds strong');
        const expiredText =  countdown.dataset.text || 'The date is expired';

            function updateCountdown() {
            const timeRemainingObj = getTimeRemaining(endTime);

            days.innerText = timeRemainingObj.days;
            hours.innerText = ('0' + timeRemainingObj.hours).slice(-2);
            minutes.innerText = ('0' + timeRemainingObj.minutes).slice(-2);
            // seconds.innerText = ('0' + timeRemainingObj.seconds).slice(-2);

            if (timeRemainingObj.total <= 0) {
                clearInterval(timeInterval);
                countdown.innerHTML = `<h2>${expiredText}</h2>`;
            }
        }

        updateCountdown();

        const timeInterval = setInterval(updateCountdown, 1000);
    }

    countdowns.forEach(countdown => {
        const dataCountDown = countdown.dataset.countdown;
        if (dataCountDown) {
            initializeCountdown(countdown, dataCountDown)
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/countdown.js